@if (!isMobile) {
  <div class="collection-report">
    <mat-card>
      <mat-card-header>
        <mat-card-title class="title">
          @if (usageType == 1) {
            <span>{{ 'TITLES.BIN_LOCATION_DESCRIPTION' | translate }}</span>
          }
          @if (usageType != 1) {
            <span>{{ 'TITLES.TANK_LOCATION_DESCRIPTION' | translate }}</span>
          }
        </mat-card-title>
      </mat-card-header>
      <mat-divider class="top-divider"></mat-divider>
      <mat-card-content>
        <div class='bin-location-container'>
          <div class='bin-info'>
            <span [ngClass]="{'cut-txt' : binName.length > 30}" title="{{binName}}">{{binName}}</span>
            @if (usageType == 1) {
              <span>&nbsp;| {{ 'LIVE_INFO.BIN_ID' | translate }} {{binId}}</span>
            }
            @if (usageType != 1) {
              <span>&nbsp;| {{ 'LIVE_INFO.TANK_ID' | translate }} {{binId}}</span>
            }
            @if (binData) {
              <span>&nbsp;| {{binData.Bin_location.bin_address}}</span>
            }
          </div>
          <div class='bin-info-description'>{{ binData && binData.bin_description ? binData.bin_description : ''}}</div>
          <google-map id="map" [options]="mapOptions" (mapInitialized)="loadAPIWrapper($event)"></google-map>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
}

@if (isMobile) {
  <div>
    <div class="accordion md-accordion" id="binLocationDescAc" role="tablist" aria-multiselectable="true">
      <div class="card mobile-card">
        <div class="card-header mobile-header">
          <div class="mobile-flex">
            @if (usageType == 1) {
              <span class="mobile-title">{{ 'TITLES.BIN_LOCATION_DESCRIPTION' | translate }}</span>
            }
            @if (usageType != 1) {
              <span class="mobile-title">{{ 'TITLES.TANK_LOCATION_DESCRIPTION' | translate }}</span>
            }
          </div>
        </div>
        <div class="collapse show" role="tabpanel" data-parent="#binLocationDescAc">
          <div class="card-body mobile-card-body">
            <div class="mobile-location-container">
              <div class="location-container-item">
                  <div class="location-container-item-title">
                      <img class="icon_img" alt="address" src="assets/images/binInfoPage/location.svg">
                      {{'LIST_COLUMNS.ADDRESS' | translate}}
                  </div>
                  <div class="location-container-item-content">
                      {{binData?.Bin_location?.bin_address}}
                  </div>
              </div>
              <div class="location-container-item">
                  <div class="location-container-item-title">
                      <img class="icon_img" alt="neighborhood" src="assets/images/binInfoPage/neighborhood.svg">
                      {{'LIST_COLUMNS.NEIGHBORHOOD' | translate}}
                  </div>
                  <div class="location-container-item-content">
                      {{binData?.Bin_location?.['bin_neighbourhood']}}
                  </div>
              </div>
              <div class="location-container-item">
                  <div class="location-container-item-title">
                      <img class="icon_img" alt="description" src="assets/images/binInfoPage/description.svg">
                      {{'LIST_COLUMNS.DESCRIPTION' | translate}}
                  </div>
                  <div class="location-container-item-content">
                      {{binData.bin_description}}
                  </div>
              </div>
              <div class="location-container-item">
                  <div class="location-container-item-title">
                      <img class="icon_img" alt="gps" src="assets/images/binInfoPage/gps.svg">
                      {{'LIST_COLUMNS.GPS' | translate}}
                  </div>
                  <div class="location-container-item-content">
                      {{'LIVE_INFO.LIVE_LAST_UPDATE' | translate }} {{calcDiff(binData?.['Bin_live_Data']?.['Transmission_data']?.last_transmission_time)}}
                      @if(user_role_id == 2 || user_role_id == 5){
                        @if(gpsRequested && !displayGpsApproval){
                          <button class="disabled-gps-sync-btn gps-sync-btn tooltip-btn" triggers="click" [autoClose]="'outside'" type="button" [ngbTooltip]="tipContent" placement="top">
                              {{'LIST_COLUMNS.REQUEST_GPS_SYNC' | translate}}
                              <img alt="gps_sync" src="assets/images/binInfoPage/gps_sync_disabled.svg">                            
                          </button> 
                          <ng-template #tipContent>
                              <div class="tooltip-content">
                                  {{'LIVE_INFO.GPS_SYNC_TIP' | translate}}
                              </div>
                          </ng-template>     
                        }@else if(gpsRequested && displayGpsApproval){
                          <button class="disabled-gps-sync-btn gps-sync-btn tooltip-btn" triggers="click" [autoClose]="'outside'" type="button" [ngbTooltip]="tipContent" placement="top">
                              {{'LIST_COLUMNS.REQUEST_GPS_SYNC' | translate}}
                              <img alt="gps_sync" src="assets/images/binInfoPage/gps_sync_disabled.svg">                            
                          </button> 
                          <ng-template #tipContent>
                              <div class="tooltip-content">
                                  {{'LIVE_INFO.GPS_SYNC_TIP_2' | translate}}
                              </div>
                          </ng-template>  
                        }@else{
                          <button (click)="requestGpsSync()" class="enabled-gps-sync-btn gps-sync-btn">
                              {{'LIST_COLUMNS.REQUEST_GPS_SYNC' | translate}}
                              <img alt="gps_sync" src="assets/images/binInfoPage/gps_sync.svg">                            
                          </button> 
                        }  
                      }                                                          
                  </div>
              </div>
            </div>   
            @if(displayGpsApproval && (user_role_id == 2 || user_role_id == 5)){
              <div class="gps-approval-container">
                  <div class="header-msg">
                    <img alt="gps_info" src="assets/images/binInfoPage/gps_info.svg">
                    {{'LIVE_INFO.GPS_APPROVAL_HEADER_MSG' | translate}}
                  </div>
                  <div class="body-container">
                      <div class="body-msg-container">
                          <div class="body-msg">{{binData?.Bin_location.bin_address}}</div>
                          <img [ngClass]="{'rotate_arrow':currentLang == 'iw' }" alt="new_gps" src="assets/images/binInfoPage/green_arrow.svg">
                          <div class="body-msg-bold">{{expectedApprovalAddress}}</div>
                      </div>
                      <div class="body-actions-container">
                          <div class="approval-btn" (click)="approveGpsResponse()">
                            <img alt="accept_gps" src="assets/images/binInfoPage/accept.svg">
                            {{'LIVE_INFO.APPROVE' | translate}}
                          </div>
                          <div class="reject-btn" (click)="rejectGpsResponse()">
                            <img alt="reject_gps" src="assets/images/binInfoPage/reject.svg">
                            {{'LIVE_INFO.REJECT' | translate}}
                          </div>
                      </div>
                  </div>
              </div>
            }
            @if(displayTheSameLocationAction && !displayGpsApproval){
              <div class="action-container location-background">
                  <div class="action-item">
                      <img alt="confirmation" src="assets/images/binInfoPage/confirmation.svg">                            
                      <div class="action-msg"> {{'LIVE_INFO.BIN_LOCATION_UPDATED_THE_SAME_LOCATION' | translate}} </div>
                  </div>
                  <img class="close-img" (click)="displayTheSameLocationAction = false" src="assets/images/reports/close.svg">
              </div>
            }
            @if(displaySuccessAction && !displayGpsApproval){
                <div class="action-container success-background">
                    <div class="action-item">
                        <img alt="approve" src="assets/images/binInfoPage/approve_ic.svg">                            
                        <div class="action-msg"> {{'LIVE_INFO.BIN_LOCATION_UPDATED_SUCCESSFULLY' | translate}} </div>
                    </div>
                    <img class="close-img" (click)="displaySuccessAction = false" src="assets/images/reports/close.svg">
                </div>
            }
            @if(displayRejectAction && !displayGpsApproval){
                <div class="action-container reject-background">
                    <div class="action-item">
                        <img alt="reject " src="assets/images/binInfoPage/reject_ic.svg">                            
                        <div class="action-msg"> {{'LIVE_INFO.BIN_LOCATION_REJECTED' | translate}} </div>
                    </div>
                    <img class="close-img" (click)="displayRejectAction = false" src="assets/images/reports/close.svg">
                </div>
            }
            <google-map [options]="mobileMapOptions" (mapInitialized)="loadAPIWrapper($event)" class="mobile-map"></google-map>
            <div class="location-history-checkbox-container" rtlDiv>
              <input type="checkbox" id="locationHistory" [(ngModel)]="showLocationHistory" (ngModelChange)="onShowLocationHistoryChange()" />
              <label for="locationHistory">{{'LIVE_INFO.LOCATION_HISTORY' | translate}}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}